export const HIDDEN_SCROLLBAR_CLASS =
  '[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden';

export const SLIM_SCROLLBAR_CLASS =
  '[scrollbar-width:thin] [scrollbar-color:var(--border)_transparent] ' +
  '[&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar]:w-2 ' +
  '[&::-webkit-scrollbar-track]:bg-transparent ' +
  '[&::-webkit-scrollbar-thumb]:rounded-full ' +
  '[&::-webkit-scrollbar-thumb]:bg-border';
